import { ProductOP } from '@cemex-core/cmx-api';
import { IProduct } from '@cemex-core/cmx-api/models/product/models/product.interface';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';

/**
 * @param {IProduct} product
 * @returns productId from product object if any
 */
export const getProductId = (product: IProduct | null): number => {
  if (product && product.product && product.product.productId) {
    return product.product.productId;
  }

  return null;
};

/**
 * @param {ProductOP} product
 * @returns productId from product object if any
 */
export const getProductIdULink = (product: ProductOP | any): number => {
  if (product && product.productId) {
    return product.productId;
  }

  return null;
};

export const getLegacyCompatibleProductIdULink = (product: any): number => {
  if (product && product.product && product.product.productId) {
    return product.product.productId;
  }

  return _safe(() => product.productId);
};


/**
 * @param {IProduct} product
 * @returns productId from product object if any
 */
export const getProductLineId = (product: IProduct | null): number => {
  if (product && product.product && product.product.productLine && product.product.productLine.productLineId) {
    return product.product.productLine.productLineId;
  } else if (product && product['productType']) {
    return product['productType'].productTypeId;
  }

  return null;
};
